import { definitionFactory } from '../definitionFactory';
import { onDeleteAction } from '../definitionsDeleteAction';

const roomLabels: Record<string, string> = {
  oneRoom: '1 комната',
  twoRoom: '2 комнаты',
  threeRoom: '3 комнаты',
  fourRoom: '4 комнаты',
  fiveRoom: '5 комнат',
  large: '6 и больше комнат',
  studio: 'Студия',
  openPlan: 'Свободная планировка',
};

export const roomDefinition = definitionFactory({
  key: 'room',
  mapper: jsonQueryValue => {
    if (!Array.isArray(jsonQueryValue) || jsonQueryValue.length === 0) {
      return [];
    }

    return jsonQueryValue.map(room => ({
      label: roomLabels[room] || room,
      value: room,
    }));
  },
  onDeleteAction: (value, options = {}) => {
    return onDeleteAction(value, 'room', options);
  },
});
